import Api from "../../axios"

export const getTemplates=async()=>{
    return await Api.get('/Game/Default-Templates')
}